// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1-Y-b","footer":"ModalInfo_footer__DvrXz"};